var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"premium-tooltip-wrapper"},[_vm._t("default"),(_vm.show)?_c('span',{staticClass:"premium-tooltip"},[_vm._v(" "+_vm._s(_vm.$t('modals.make_direct_referal_modal.inivte_billing.subscribe_to_premium'))+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }